import React, { useState, useEffect, useRef, createContext, useContext } from 'react';
import LeftNav from '../common/leftnav/leftnav';
import HeaderTop from '../common/headerTop/headerTop';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import { useHistory } from 'react-router-dom';
import CommonMessage from '../common/commonMessage';
import LoadBalancerService from './loadbalancerapis';
import { ResourceService } from '../../services/resource.service';
import $ from 'jquery';
import * as importedMessages from './constants';
import { getFullRegionDetail } from '../../utility/utility';
import ReactToolTip from 'react-tooltip';
import { axiosInstance, axiosRequestWithAuth } from '../../constants/server.constant';
const isValidDomain = require('is-valid-domain');
const parentContextMain = createContext();

const ListLoadBalancerMain = () => {
    const [isAction, setIsAction] = useState(true);
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState("");
    const [isUserSubscribed, setIsUserSubscribed] = useState(true);
    const [lbList, setLbList] = useState([]);
    const [isApiCallRequired, setIsApiCallRequired] = useState(true);
    const [isApiCall, setIsApiCall] = useState(true);
    const interval = useRef();
    const [isEditRdns, setIsEditRdns] = useState(false);
    const [editRdnsData, setEditRdnsData] = useState("");
    const [currIdx, setCurrIdx] = useState("");
    const [indexCount, setIndexCount] = useState(0);
    const [pagedLbList, setPagedLbList] = useState([]);
    const [paginationCount, setPaginationCount] = useState(50);
    useEffect(() => {
        setIsAction(true);
        checkForSubscription();

    }, []);


    // useEffect(() => {
    //     let interval = null;
    //     if(isApiCallRequired) {
    //         interval = setInterval(() => {
    //             getLoadBalancerDetails();
    //         }, 20000);

    //     }
    //     else {
    //         clearInterval(interval)
    //     }


    // },[isApiCallRequired,isApiCall])

    const checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            // console.log(resp);
            if(resp === false) {
                setIsAction(false);
                setMsgType('error');
                setMessage("Error while getting user subscription details");
                return;
            }
            if(resp.error) {
                setIsAction(false);
                setIsUserSubscribed(true);
            }
            else {
                getLoadBalancerDetails(false);
            }

        });
    };

    const getLoadBalancerDetails = (isNonCached) => {
        LoadBalancerService.getLoadBalList(isNonCached).then(resp => {

            if(resp && resp?.data) {
                let data = resp.data;
                let loadList = [];
                let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
                for(let region of Object.keys(data)) {
                    let getList = data[region];
                    for(let i = 0; i < getList.length; i++) {
                        let UTCtime = getList[i].created_at + "Z";
                        let d = new Date(UTCtime);
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ', ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        let listObj = {
                            "name": getList[i].name,
                            "ip": getList[i].ip_address === "FAILED_IP" ? "N/A" : getList[i].ip_address,
                            "region": getFullRegionDetail(fullRegionList, region.toUpperCase()),
                            "regionId": region,
                            "status": getList[i].provisioning_status == "PENDING_CREATE"
                                || getList[i].provisioning_status == "PENDING_DELETE"
                                || getList[i].provisioning_status == "PENDING_UPDATE"
                                ? "Pending" : getList[i].provisioning_status.toLowerCase(),
                            "originalStatus": getList[i].provisioning_status,
                            "operationStatus": getList[i].operating_status.toLowerCase(),
                            "date": createdDate,
                            "id": getList[i].id
                        };
                        loadList.push(listObj);
                    }
                    // if(loadBal.hasOwnProperty("loadbalancers")) {
                    //     let getList = loadBal.loadbalancers;
                    //     for(let i = 0; i < getList.length; i++){
                    //          let UTCtime = getList[i].created_at+"Z"
                    //         let d = new Date(UTCtime);
                    //         let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ', ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                    //             hour: '2-digit',
                    //             minute: '2-digit'
                    //         });
                    //         let listObj = {
                    //             "name": getList[i].name,
                    //             "ip": getList[i].vip_address,
                    //             "region": getFullRegionDetail(fullRegionList, region.toUpperCase()),
                    //             "regionId": region,
                    //             "status": getList[i].provisioning_status == "PENDING_CREATE"
                    //                 || getList[i].provisioning_status == "PENDING_DELETE"
                    //                 ? "Pending" : getList[i].provisioning_status.toLowerCase(),
                    //             "originalStatus": getList[i].provisioning_status,
                    //             "operationStatus":getList[i].operating_status.toLowerCase(),
                    //             "date": createdDate,
                    //             "id":getList[i].id
                    //         }
                    //         loadList.push(listObj)
                    //     }
                    // }
                }
                let intervalFlag = false;
                for(let i = 0; i < loadList.length; i++) {
                    if(loadList[i].status === "Pending") {
                        intervalFlag = true;
                        break;
                    }

                }

                if(intervalFlag) {
                    setTimeout(() => {
                        getLoadBalancerDetails(true);
                    }, 15000);

                }
                let key = "date";
                loadList.sort((a, b) => {

                    let curr = new Date(a[key]);
                    let next = new Date(b[key]);
                    return next - curr;

                });

                let pagedLbList = [...loadList];
                if(pagedLbList.length > paginationCount) pagedLbList = pagedLbList.slice(0, paginationCount);


                setLbList(loadList);
                setPagedLbList(pagedLbList);
                setIndexCount(0);
                setIsAction(false);
            }
            else {
                setMessage("An error occurred. Please try again");
                setIsAction(false);
            }

        }).catch(error => {
            setMessage("An error occurred. Please try again");
            setIsAction(false);
        });
    };


    const updateEdit = () => {
        setIsEditRdns(!isEditRdns);
    };

    return (
        <parentContextMain.Provider value={ {
            setMsgType, setMessage, setIsAction, lbList, setLbList, getLoadBalancerDetails, isAction,
            isEditRdns, setIsEditRdns, editRdnsData, setEditRdnsData, indexCount, setIndexCount,
            pagedLbList, setPagedLbList, paginationCount, setPaginationCount
        } }>
            <div className="main_nav_module loadBalance_module">
                <main>
                    <FullPageLoader isLoad={ isAction } />
                    <LeftNav isActive={ 'loadbal' } />
                    <div className="main_container">
                        <TopHeader lenOfLb={ lbList.length } />
                        <NotificationSlider />
                        <DisplayLoadBalancers />
                    </div>
                </main>
                {
                    isEditRdns && <EditRDNSSlider currentIndex={ currIdx } edit={ isEditRdns } updateEdit={ updateEdit } editRdnsData={ editRdnsData } />
                }
                <CommonMessage message={ message } msgType={ msgType } isUserSubscribed={ isUserSubscribed } handler={ () => setMessage('') } />
            </div>
        </parentContextMain.Provider >
    );
};

const TopHeader = (props) => {
    const history = useHistory();
    const redirectToCreate = (event) => {
        event.preventDefault();
        history.push('/create-loadbalancer');
    };
    return (
        <header className="header_wrap">
            <HeaderTop />
            <div className="header_wrap_bottom">
                <div className="bottom_navbar">
                    <div className="bn_left">
                        <div className="computer_no">
                            <span className="text bold_600">Load Balancers</span>
                        </div>
                    </div>
                    <div className="bn_right">
                        <div className="rhs_info">
                            <p>Number of load balancers : { props.lenOfLb }</p>
                        </div>
                        { props.lenOfLb != 0 &&
                            <>
                                <div className="divider"></div>
                                <div className="rhs_cta">
                                    <div className="btn_wrap_icon">
                                        <input type="button" name="" value="Create Load Balancer" className="common_cta_btn blue" onClick={ (e) => redirectToCreate(e) } />
                                    </div>
                                </div>
                            </> }
                    </div>
                </div>
            </div>
        </header>
    );
};
const EmptyLoadBalancers = () => {
    const history = useHistory();
    const redirectToCreate = (event) => {
        event.preventDefault();
        history.push('/create-loadbalancer');
    };
    return (
        <ul>
            <li>
                <div className="outer_empty_wrap fullPageEmpty">
                    <div className="inner_empty_wrap">
                        <div className="svg_wrap empty_icon sshKeyCreate_empty"></div>
                        <p className="empty_head">Load Balancers</p>
                        <p className="empty_title">Create load balancers for your account.</p>
                        <div className="btn_wrap_icon btnDefaultPad"><input type="button" value="Create Load Balancer" className="common_cta_btn blue" onClick={ (e) => redirectToCreate(e) }></input></div>
                    </div>
                </div>
            </li>
        </ul>
    );
};

const DisplayLoadBalancers = () => {
    let history = useHistory();
    const { setMsgType, setMessage, setIsAction, lbList, setLbList, isAction
        , isEditRdns, setIsEditRdns, editRdnsData, setEditRdnsData, indexCount, setIndexCount,
        pagedLbList, setPagedLbList, paginationCount, setPaginationCount
    } = useContext(parentContextMain);
    const [isDelete, setIsDelete] = useState(false);
    const [currIdx, setCurrIdx] = useState("");
    const [deleteData, setDeleteData] = useState("");
    const [isCopied, setIsCopied] = useState(false);

    const toogleActionsMenu = (target) => {
        $(target).closest('.tr').find('.loadBalance_row_options').toggleClass('active');
    };

    const handleLoadBalancer = (event, loadbalancer, index) => {
        setCurrIdx(index);
        toogleActionsMenu(event.currentTarget);
    };
    const loadBalancerOperation = (event, type, data) => {
        if(data.status.toLowerCase().indexOf("pending") != -1) {
            return;
        }
        toogleActionsMenu(event.currentTarget);
        setDeleteData(data);
        setEditRdnsData(data);
        if(type === "manage") {
            history.push({
                pathname: '/manage-loadbalancer',
                search: '?loadBalancer=' + data.id,
                state: { loadBalData: data }
            });
        }
        if(type === "delete") {
            $('body').addClass("popup_no_scroll");
            setIsDelete(true);
        }
        if(type === "editRDNS") {
            $('body').addClass("popup_no_scroll");
            setIsEditRdns(true);
        }

    };

    const updateEnable = () => {
        setIsDelete(!isDelete);
    };

    const updateEdit = () => {
        setIsEditRdns(!isEditRdns);
    };

    const sortLb = (event, source) => {
        let toSort;
        let bool1 = $(event.currentTarget).find('.sort_icon').hasClass('toggle_sort');
        if(bool1) {
            $(event.currentTarget).find('.sort_icon').removeClass('toggle_sort');
            toSort = "ascending";
        }
        else {
            let bool2 = $(event.currentTarget).find('.sort_icon').hasClass('active');
            if(bool2) {
                $(event.currentTarget).find('.sort_icon').addClass('toggle_sort');
                toSort = "descending";
            }
            else {
                if($('.sort_icon').hasClass('toggle_sort')) {
                    $('.sort_icon').removeClass('active toggle_sort');
                }
                if($('.sort_icon').hasClass('active')) {
                    $('.sort_icon').removeClass('active ');
                }
                $(event.currentTarget).find('.sort_icon').addClass('active toggle_sort');
                toSort = "descending";
            }
        }
        sortdataBasedOnKey(lbList, source, toSort);
    };

    const sortdataBasedOnKey = (data, key, order) => {
        let sortedList = [...data];
        if(key === "date") {
            sortedList.sort((a, b) => {

                let curr = new Date(a[key]);
                let next = new Date(b[key]);

                if(order == "descending") {
                    return next - curr;
                }
                else {
                    return curr - next;
                }
            });
        }
        else {

            sortedList.sort((a, b) => {
                let curr = a[key];
                let next = b[key];
                if(order == "descending") {
                    return (curr < next) ? -1 : ((curr > next) ? 1 : 0);
                }
                else {
                    return (curr > next) ? -1 : ((curr < next) ? 1 : 0);
                }
            });
        }
        let pagedLbList = [...sortedList];
        if(pagedLbList.length > paginationCount) pagedLbList = pagedLbList.slice(0, paginationCount);


        setLbList(sortedList);
        setPagedLbList(pagedLbList);
        setIndexCount(0);
    };

    const copyToclipboard = (event, text) => {
        var container = event.currentTarget;
        let tempInnerHtml = container.innerHTML;
        container.innerHTML = text;
        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNode(container);
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        container.innerHTML = tempInnerHtml;
        setIsCopied(true);
    };

    const handleNextClick = (event) => {
        let localLbList = [...lbList];
        let localCount = indexCount + paginationCount;
        let endCount = localCount + paginationCount;
        if(endCount > localLbList.length) endCount = localLbList.length;
        setIndexCount(localCount);
        setPagedLbList(localLbList.slice(localCount, endCount));
        event.preventDefault();
    };

    const handlePreviousClick = (event) => {
        let localLbList = [...lbList];
        let localCount = indexCount - paginationCount;
        setIndexCount(indexCount - paginationCount);
        setPagedLbList(localLbList.slice(localCount, indexCount));
        event.preventDefault();
    };

    return (
        <>
            {
                isDelete && <DeleteLoadBalancerPopup currentIndex={ currIdx } enable={ isDelete } updateEnable={ updateEnable } deleteData={ deleteData } />
            }

            <section className="main_section">
                <div className="main_body_container">
                    <div className="mainBody_colWrap">
                        <div className="loadBalance_container">
                            <div className="loadBalance_table">
                                <div className="tabular_data_wrap">
                                    <div className="table_header">
                                        <ul>
                                            <li className="th">
                                                <div className="col col1" onClick={ (e) => sortLb(e, "name") } >
                                                    <div className="header_sort_wrap" >Name<span className="sort_icon" ></span></div>
                                                </div>
                                                <div className="col col2" onClick={ (e) => sortLb(e, "operationStatus") }>
                                                    <div className="header_sort_wrap">Operating Status<span className="sort_icon" ></span></div>
                                                </div>
                                                <div className="col col3">
                                                    <div className="">IP Address</div>
                                                </div>
                                                <div className="col col4" onClick={ (e) => sortLb(e, "region") }>
                                                    <div className="header_sort_wrap" >Region<span className="sort_icon" ></span></div>
                                                </div>
                                                <div className="col col5" onClick={ (e) => sortLb(e, "status") }>
                                                    <div className="header_sort_wrap" >Provisioning Status<span className="sort_icon" ></span></div>
                                                </div>
                                                <div className="col col6" onClick={ (e) => sortLb(e, "date") }>
                                                    <div className="header_sort_wrap " >Created On<span className="sort_icon active" ></span></div>
                                                </div>
                                                <div className="col col7">
                                                    <div >Actions</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="table_data">
                                        { (lbList.length === 0 && !isAction) ?
                                            <EmptyLoadBalancers />
                                            :
                                            <ul>
                                                { pagedLbList.map((loadbalancer, idx) =>
                                                    <li className={ "tr " + loadbalancer.status.toLowerCase() } key={ idx } >
                                                        <div className="table_col_wrap">

                                                            <div className="col col1" onClick={ (e) => loadBalancerOperation(e, "manage", loadbalancer) }>
                                                                <div className="name_icon">
                                                                    <span className="svg_wrap">
                                                                        <svg x="0px" y="0px" width="18px" height="18px" viewBox="0 0 18 18" style={ { enableBackground: "new 0 0 18 18" } } xmlSpace="preserve">
                                                                            <g>
                                                                                <rect x="3" y="3.5" className="lb_list1" width="12" height="3" />
                                                                                <rect x="1" y="11.4" className="lb_list1" width="4" height="3" />
                                                                                <rect x="7" y="11.4" className="lb_list1" width="4" height="3" />
                                                                                <rect x="13" y="11.4" className="lb_list1" width="4" height="3" />
                                                                                <path className="lb_list1" d="M3,11.4V9.7c0-0.2,0.1-0.3,0.3-0.3h11.4c0.2,0,0.3,0.1,0.3,0.3v1.7" />
                                                                                <line className="lb_list1" x1="9" y1="11.6" x2="9" y2="6.7" />
                                                                            </g>
                                                                        </svg>
                                                                    </span>
                                                                </div>
                                                                <span className="loadBalance_Name"><span>{ loadbalancer.name }</span></span>
                                                            </div>
                                                            <div className="col col2">
                                                                <span className={ loadbalancer.operationStatus.toLowerCase() === "online" ?
                                                                    "server_status active" : "server_status " + loadbalancer.operationStatus.toLowerCase()
                                                                }>{ loadbalancer.operationStatus.charAt(0).toUpperCase() + loadbalancer.operationStatus.slice(1) }</span>
                                                            </div>
                                                            <div class="col col3">
                                                                <div class="ip_address_show">{ loadbalancer.ip } </div>
                                                                <div class="ip_address_copy" style={ { display: loadbalancer.ip === "N/A" ? "none" : "" } }>
                                                                    <span class="svg_wrap" data-tip data-for="copy" onClick={ (e) => copyToclipboard(e, loadbalancer.ip) } onMouseLeave={ () => { setIsCopied(false); } }>
                                                                        <svg x="0px" y="0px" width="14px" height="16.5px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                                                        </svg>
                                                                    </span><ReactToolTip id="copy" place="right" effect="solid">{ isCopied ? "Copied" : "Copy" }</ReactToolTip>
                                                                </div>
                                                            </div>
                                                            <div className="col col4">
                                                                <span className="txt">{ loadbalancer.region }</span>
                                                            </div>
                                                            <div className="col col5">
                                                                <span className="txt lbstatus">{ loadbalancer.status.charAt(0).toUpperCase() + loadbalancer.status.slice(1) }</span>
                                                            </div>
                                                            <div className="col col6">
                                                                <span className="txt">{ loadbalancer.date }</span>
                                                            </div>
                                                            <div className="col col7" >
                                                                <span className="menu_icon" >
                                                                    <span className="svg_wrap" onClick={ (e) => handleLoadBalancer(e, loadbalancer, idx) }>
                                                                        <svg className="horizMenuIcon" data-tip="true" data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve" currentitem="false">
                                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                        </svg>
                                                                    </span>
                                                                    <ul className="dropdown_component loadBalance_row_options ">
                                                                        <span className="arrow_pointer"></span>
                                                                        <li className="manage" style={ { display: loadbalancer.status.toLowerCase() === "error" ? "none" : "" } } onClick={ (e) => loadBalancerOperation(e, "manage", loadbalancer) }>
                                                                            <span className="icon">
                                                                                <span className="svg_wrap">
                                                                                    <svg x="0px" y="0px" width="22.2px" height="22.2px" viewBox="0 0 22.2 22.2" style={ { enableBackground: "new 0 0 22.2 22.2" } } xmlSpace="preserve">
                                                                                        <g>
                                                                                            <path className="mn2" d="M3.8,5.5C5.5,3.3,8.1,2,11,2c5.1,0,9.3,4.2,9.3,9.3s-4.2,9.3-9.3,9.3c-4.6,0-8.5-3.4-9.2-7.8" />
                                                                                            <polygon className="mn3" points="7.7,7.1 2.2,7.1 2.2,1.6  " />
                                                                                            <path className="mn4" d="M14.6,12.1c0-0.3,0-0.6,0-0.8l0.9-0.7c0.1-0.1,0.2-0.3,0.1-0.4l-0.2-0.5c-0.1-0.1-0.2-0.2-0.3-0.2l-1.1,0.1
                                                    c-0.2-0.2-0.4-0.4-0.6-0.6l0.1-1.1c0-0.2-0.1-0.3-0.2-0.4l-0.6-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1l-0.7,0.9h-0.5h-0.4
                                                    L10,7.3C9.9,7.2,9.8,7.1,9.7,7.1c0,0-0.1,0-0.1,0L9.1,7.3C8.9,7.4,8.8,7.6,8.8,7.7L9,8.8C8.7,9,8.5,9.2,8.3,9.4L7.2,9.3
                                                    c-0.1,0-0.3,0.1-0.3,0.2L6.7,10c-0.1,0.1,0,0.3,0.1,0.4l0.8,0.7c0,0.3,0,0.6,0,0.9l-0.8,0.7c-0.1,0.1-0.2,0.3-0.1,0.4l0.2,0.5
                                                    c0.1,0.1,0.2,0.2,0.3,0.2l1-0.1c0.2,0.3,0.4,0.5,0.6,0.7l-0.1,1c0,0.2,0.1,0.3,0.2,0.4l0.5,0.2c0,0,0.1,0,0.1,0
                                                    c0.1,0,0.2,0,0.3-0.1l0.7-0.8c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0l0.7,0.8c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0.1,0,0.1,0l0.5-0.2
                                                    c0.1-0.1,0.2-0.2,0.2-0.4l-0.1-1.1c0.2-0.2,0.4-0.4,0.6-0.6l1.1,0.1c0.1,0,0.3-0.1,0.3-0.2l0.2-0.5c0.1-0.1,0.1-0.3-0.1-0.5
                                                    L14.6,12.1z M11.2,13.2C11.2,13.2,11.1,13.2,11.2,13.2c-0.9,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5
                                                    C12.6,12.5,12,13.1,11.2,13.2z"/>
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                            </span>
                                                                            Manage
                                                                        </li>
                                                                        { loadbalancer.ip === "N/A" ? "" :
                                                                            <li class="edit edit_rdns" onClick={ (e) => loadBalancerOperation(e, "editRDNS", loadbalancer) }>
                                                                                <span class="icon">
                                                                                    <span class="svg_wrap">
                                                                                        <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                                                                    </span>
                                                                                </span>
                                                                                Edit RDNS
                                                                            </li>
                                                                        }

                                                                        <li className="delete" onClick={ (e) => loadBalancerOperation(e, "delete", loadbalancer) }>
                                                                            <span className="icon">
                                                                                <span className="svg_wrap">
                                                                                    <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </span>
                                                                            Delete
                                                                        </li>
                                                                    </ul>
                                                                </span>
                                                            </div>
                                                        </div>

                                                        { loadbalancer.status.toLowerCase() === "pending" && <div className="boot_container">
                                                            <div className="boot_wrapper">
                                                                <div className="progress_wrap">
                                                                    <div className="title_head">
                                                                        <span className="head_title">{ loadbalancer.originalStatus === "PENDING_CREATE" ? "Creating load balancer" : loadbalancer.originalStatus === "PENDING_UPDATE" ? "Updating load balancer" : "Deleting load balancer" } </span><span style={ { "display": "none" } } className="percent_num">85%</span>
                                                                    </div>
                                                                    <div className="progress_bar">
                                                                        <span className="percent_progress" style={ { "width": "85%" } }></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> }
                                                    </li>
                                                ) }
                                            </ul>
                                        }
                                    </div>
                                    <div className="pagination_inner__box remove-bg" style={ { display: lbList.length >= paginationCount ? '' : 'none' } }>
                                        <div className="Page_navigation">
                                            <ul className="pagination_ul">
                                                <li className={ indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                    <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { handlePreviousClick(event); } }>
                                                        <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                        <span aria-hidden="true">«</span>
                                                        <span className="sr-only">Previous</span>
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                        { indexCount + 1 } - { (indexCount + paginationCount) > lbList.length ? lbList.length : (indexCount + paginationCount) }
                                                    </a>
                                                </li>
                                                <li className={ indexCount + paginationCount > lbList.length - 1 ? "page-item disabled" : "page-item" }>
                                                    <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { handleNextClick(event); } }>
                                                        <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                        <span aria-hidden="true">»</span>
                                                        <span className="sr-only">Next</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};


const EditRDNSSlider = (props) => {
    const { setMsgType, setMessage, setIsAction, lbList, setLbList, getLoadBalancerDetails } = useContext(parentContextMain);
    const { edit, updateEdit } = props;
    const { editRdnsData, setEditRdnsData } = props;
    const [rdnsValue, setRdnsValue] = useState("");
    const [isEditDisabled, setIsEditDisabled] = useState(false);
    const [isRdnsError, setIsRdnsError] = useState(false);
    const [rdnsErrorMsg, setRdnsErrorMsg] = useState("");
    const [isMatchFound, setIsMatchFound] = useState(false);
    const [rdnsStatus, setRdnsStatus] = useState(0);
    const [rdnsid, setRdnsId] = useState(-1);
    const [existingRdns, setExistingRdns] = useState("");
    const [isLoader, setIsLoader] = useState(false);
    useEffect(() => {
        const handleEsc = (event) => {
            if(event.keyCode === 27) {
                updateEdit(false);
                $('body').removeClass("popup_no_scroll");
            }
        };
        window.addEventListener('keydown', handleEsc, false);

        return () => {
            window.removeEventListener('keydown', handleEsc, false);
        };

    }, []);

    useEffect(() => {
        setIsAction(true);
        getRdnsData();
    }, []);

    const checkDomain = async () => {
        try {
            let resp = await axiosInstance.post('/rdns/domainCheck', { ip: editRdnsData.ip }, axiosRequestWithAuth);
            return resp.data;
        }
        catch(error) {
            console.log(error);
        }
    };

    const clearToastMessage = () => {
        setTimeout(() => {
            setMessage("");
        }, 10000);
    };

    const getRdnsData = () => {

        axiosInstance.get("/rdns/" + editRdnsData.id + "/all", axiosRequestWithAuth).then(resp => {
            let data = resp.data;
            let isMatch = false;
            checkDomain().then(resp => {
                let matchedRdnsDefault = resp;
                //debugger
                for(var i = 0; i < data.length; i++) {
                    //debugger
                    if(data[i].ipAddress == editRdnsData.ip) {
                        setIsMatchFound(true);
                        isMatch = true;
                        if(data[i].status !== 1) {
                            data[i].rdns = matchedRdnsDefault;
                        }
                        setRdnsId(data[i].id);
                        setRdnsValue(data[i].rdns);
                        setExistingRdns(data[i].rdns);
                        setRdnsStatus(data[i].status);
                        break;

                    }

                }
                if(!isMatch) {
                    setRdnsId(-1);
                    setRdnsValue(matchedRdnsDefault);
                    setExistingRdns(matchedRdnsDefault);
                    setRdnsStatus(0);
                }
                setIsAction(false);

            });




        }).catch(err => {
            console.log(err);
            setIsAction(false);
        });

    };

    const OnEditRdns = (e) => {
        setIsEditDisabled(true);
        setIsLoader(true);
        if(rdnsValue && rdnsValue === existingRdns) {
            setIsEditDisabled(false);
            setIsLoader(false);
            setIsRdnsError(true);
            setRdnsErrorMsg("There is no change in the existing Reverse DNS forward entry. Enter a Reverse DNS forward entry that already exists in the record");
            return;
        }
        if(!rdnsValue) {
            setIsEditDisabled(false);
            setIsLoader(false);
            setIsRdnsError(true);
            setRdnsErrorMsg("Enter a domain to perform the Reverse DNS lookup");
            return;

        }
        if(!isValidDomain(rdnsValue, { subdomain: true })) {
            setIsEditDisabled(false);
            setIsLoader(false);
            setIsRdnsError(true);
            setRdnsErrorMsg("Enter a valid domain");
            return;

        }
        axiosInstance.post('/rdns/' + 'rdnsLookup', { ip: editRdnsData.ip, rdns: rdnsValue }, axiosRequestWithAuth).then((resp) => {
            let inputmapExists = resp.data;
            if(isValidDomain(rdnsValue, { subdomain: true }) && inputmapExists) {
                $(".reverseDnsSlider").removeClass("active");

                if(rdnsid !== -1) {

                    upateInstanceRdnsData(rdnsid, rdnsStatus, rdnsValue);
                    setIsEditDisabled(false);
                    setIsLoader(false);
                    setIsRdnsError(false);
                }
                if(rdnsid === -1) {
                    //console.log("called create")
                    createInstanceRdnsData(rdnsValue, editRdnsData.ip, "Public").then((resp) => {
                        setIsEditDisabled(false);
                        setIsLoader(false);
                        setIsRdnsError(false);
                    });
                }
            }
            else if(!inputmapExists) {
                setIsEditDisabled(false);
                setIsRdnsError(true);
                setIsLoader(false);
                setRdnsErrorMsg("No DNS A record found for \"" + rdnsValue + "\" pointing to \"" + editRdnsData.ip + "\". Please create a DNS A record for \"" + rdnsValue + "\" before requesting a Reverse DNS record. If you have updated your domain service recently, the changes may take some time to reflect.");

            }
        });
    };

    const createInstanceRdnsData = async (rdnsVal, addr, type) => {
        try {
            let resp = await axiosInstance.post('/rdns/' + localStorage.getItem('userId'),
                {
                    instanceId: editRdnsData.id,
                    ipAddress: addr,
                    ipAddressType: type,
                    rdns: rdnsVal,
                    instanceName: editRdnsData.name
                }, axiosRequestWithAuth);
            //console.log(resp)
            if(resp.status === 200) {
                setMessage("Your request to update PTR record for the instance has been submitted. Our team is looking into it and you will be informed via email.");
                clearToastMessage();
            }
            else {
                setMessage("Error while sending request.Please try after sometime", "error");
                clearToastMessage();
            }
            return resp.data;
        }
        catch(error) {
            console.log(error);
            setMessage("Error while sending request.Please try after sometime", "error");
            clearToastMessage();
        }
    };

    const upateInstanceRdnsData = (id, status, updatedRdns) => {
        axiosInstance.post("/rdns/" + status + "/" + id + "/" + localStorage.getItem("userId"),
            {
                rdns: updatedRdns,
                userId: localStorage.getItem('userId'),
                instanceName: editRdnsData.name
            }
            , axiosRequestWithAuth)
            .then(resp => {
                if(resp.status === 200) {
                    setMessage("Your request to update PTR record for the instance has been submitted. Our team is looking into it and you will be informed via email.");
                    clearToastMessage();
                }
                else {
                    setMessage("Error while sending request.Please try after sometime", "error");
                    clearToastMessage();
                }

            }).catch(err => {
                console.log(err);
                setMessage("Error while sending request.Please try after sometime", "error");
                clearToastMessage();
            });
    };

    const onCancelEditRdns = (e) => {
        $('body').removeClass("popup_no_scroll");
        updateEdit();
    };

    const handleRdns = (event) => {

        let val = event.target.value;
        setRdnsValue(val);
        setIsEditDisabled(false);
        setIsRdnsError(false);
        setRdnsErrorMsg(false);
        setIsLoader(false);
    };

    return (
        <div class={ `main_slider lbreverseDnsSlider ${ edit ? "active" : "" }` }>
            <div class="slider_bg_shadow"></div>
            <div class="slider_wrapper">
                <div class="main_slider_container">
                    <div class="close_icon" data-for="editClose" data-tip onClick={ (e) => { onCancelEditRdns(e); } }></div>
                    <ReactToolTip id='editClose' effect='solid' place='left'>Close</ReactToolTip>
                    <div class="ntwk_rhs_slide_wrap">
                        <div class="head_block">
                            <h2>Edit Reverse DNS</h2>
                        </div>
                        <div class="ntwkRhs_content_wrap">
                            <div class="common_txtBox_row"><label>Enter a pointer record to perform Reverse DNS lookup</label>
                                <input type="text" id="rdnsText" autocomplete="off" class="txt_box" value={ rdnsValue } onChange={ (e) => handleRdns(e) } />
                                <span class="err_msg" style={ { display: isRdnsError ? "block" : "none", color: "red" } } >{ rdnsErrorMsg } </span>
                            </div>
                            <p class="info_txt"><strong>Note:</strong> A pointer record must exist for the requested domain to perform RDNS lookup</p>
                            <div class="cta_wrap">
                                <input type="button" name="" class="common_cta_btn blue" value="Request" onClick={ (e) => { OnEditRdns(e); } } disabled={ isEditDisabled } />
                                <input type="button" name="" class="common_cta_btn transparentGrey" value="Cancel" onClick={ (e) => { onCancelEditRdns(e); } } />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};


const DeleteLoadBalancerPopup = (props) => {

    const { setMsgType, setMessage, setIsAction, lbList, setLbList, getLoadBalancerDetails } = useContext(parentContextMain);
    const { enable, updateEnable } = props;
    const { deleteData, setDeleteData } = props;
    useEffect(() => {
        const handleEsc = (event) => {
            if(event.keyCode === 27) {
                updateEnable(false);
                $('body').removeClass("popup_no_scroll");
            }
        };
        window.addEventListener('keydown', handleEsc, false);

        return () => {
            window.removeEventListener('keydown', handleEsc, false);
        };
    }, []);
    const onDeleteLoadBalancer = (e) => {
        setIsAction(true);
        LoadBalancerService.deleteLoadBalancer(deleteData.id, deleteData.regionId).then(resp => {
            resp = resp.data;
            if(resp.body.deleted) {
                getLoadBalancerDetails(true);
                setMsgType('');
                setMessage('Load Balancer ' + deleteData.name + " has been deleted");
                $('body').removeClass("popup_no_scroll");
                return;
            }
            setMsgType('');
            setMessage('Error while deleting load balancer ' + deleteData.name);
            $('body').removeClass("popup_no_scroll");
            setIsAction(false);
        }
        ).catch(err => {
            setMsgType('');
            setMessage('Error while deleting load balancer ' + deleteData.name);
            $('body').removeClass("popup_no_scroll");
            setIsAction(false);
        });
        onCancelLoadBalancer(e);
    };

    const onCancelLoadBalancer = (e) => {
        $('body').removeClass("popup_no_scroll");
        updateEnable();
    };

    return (
        <div className={ `main_popup delete_loadBalance_popup ${ enable ? "active" : "" }` }>
            <div className="main_popup_wrapper">
                <div className="main_popup_bg_shadow"></div>
                <div className="main_popup__inner">
                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ (e) => onCancelLoadBalancer() }></span>
                        <div className="popup_header">
                            <div className="sub_title"> Delete { deleteData.name }</div>
                        </div>
                        <div className="popup_body">
                            <p>Are you sure you want to delete the load balancer?</p>
                        </div>
                        <div className="popup_footer">
                            <div className="popup_footer__btns">
                                <div className="btn btn_confirm" onClick={ (e) => onDeleteLoadBalancer() }>Delete</div>
                                <div className="btn btn_cancel" onClick={ (e) => onCancelLoadBalancer() }>Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

const FullPageLoader = (props) => {
    return (
        <div className="full_page_loader" style={ { display: props.isLoad ? "block" : "none" } }>
            <div className="loader_icon"></div>
        </div>
    );
};

export default ListLoadBalancerMain;